<template>
  <div class="xpage-search-results-buttons">
    <div
      class="xfilter-button"
      v-if="searchPageStore.searchPageState.search.active"
      @click="
        searchPageStore.clearSearchbox();
        searchPageStore.triggerSearch(
          searchPageStore.searchPageState.entity,
          null,
          searchPageStore.searchPageState.query.pageNumber
        );
      "
    >
      {{ "Search: " + searchPageStore.searchPageState.search.text }}
    </div>
    <div
      class="xfilter-button"
      v-for="(item, index) in searchPageStore.selectedFilters()"
      @click="searchPageStore.clearFilter(item)"
      :key="index"
    >
      {{ item.name }}
    </div>
    <div
      class="xfilter-button"
      v-if="searchPageStore.selectedFilters().length > 1"
      @click="
        searchPageStore.clearAllFiltersAndSearch(
          searchPageStore.searchPageState.entity
        )
      "
      data-type="clear"
    >
      Clear All
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSearchPageStore } from "@/store/store/searchPageStore";

const searchPageStore = useSearchPageStore();
</script>

<style scoped>
/* filter buttons */
div.xfilter-button {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  background: black;
  display: inline-block;
  color: white;
  font-size: 13px;
  line-height: 36px;
  padding: 0 15px;
  border-radius: 50px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid black;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

div.xfilter-button:after {
  content: "X";
  margin-left: 7px;
  color: #c5c5c5;
}

div.xfilter-button[data-type="clear"] {
  color: black;
  background: transparent;
}

div.xfilter-button[data-type="clear"]:after {
  display: none;
  content: none;
}
</style>
